






import { Payment } from '@/models/api/payment/payment'
import AmazonPayOnetime from '@spa/components/organisms/order/edit/payment/select/description/amazon-pay/AmazonPayOnetime.vue'
import Vue, { VueConstructor } from 'vue'
import { Component, Prop } from 'vue-property-decorator'

@Component
export default class PaymentDescription extends Vue {
  @Prop({ required: true })
  readonly payment: Payment

  get description(): VueConstructor {
    /**
     * 将来的に、単にサーバーが返したhtmlをレンダリングするだけでなく、
     * サーバー側が指定したスクリプトの実行を伴うかもしれない
     * @see https://github.com/my-color/front/pull/7085
     */
    return Vue.extend({
      name: `${this.payment.id}PaymentDescription`,
      template: this.payment.description,
      components: {
        /**
         * Amazon Payに関しては、もしかしたらクレジットカードと同じような独立したレイアウトにするかも？
         * 一旦仮置で、Amazon Payを操作可能な状態に持っていく
         */
        'amazon-pay-onetime': AmazonPayOnetime,
      },
    })
  }
}
